import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'permission_tag_stream_group_list_info';
export const usePermissionTagStreamGroupListInfoTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => {
  return useTranslation('widgets', { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Группы',
    empty: 'К этому тегу не привязаны группы',
    error: 'Не удалось загрузить группы',
    detach_disabled: 'Группа не принадлежит вашему подразделению',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Groups',
    empty: 'No groups are attached to this tag',
    error: 'Could not load groups',
    detach_disabled: 'The group does not belong to your department',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Grupos',
    empty: 'No hay grupos vinculados a esta etiqueta de permiso',
    error: 'No se pudieron cargar los grupos',
    detach_disabled: 'El grupo no pertenece a su departamento',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Grupos',
    empty: 'Nenhum grupo esta vinculado a esta tag de permissao',
    error: 'Nao foi possivel carregar os grupos',
    detach_disabled: 'O grupo não pertence ao seu departamento',
  },
}) : {}) as Record<string, unknown>;
